// Firestore に置く個人情報・取引先の情報の形（仕様書「Firestore（個人情報）」）。ドキュメントの ID は D1 の ID と同じ。
// 守りは firebase/firestore.rules。ここを変えたら Security Rules とそのテストも直す
export type MemberDoc = { kind: 'staff' | 'driver'; id: string };
/** retireAt：この時刻からログインできない（退職の最終出勤日の翌日 0 時。Firestore の Timestamp） */
type Retirement = { retireAt?: { toDate(): Date } | null };
export type StaffDoc = { officeId: string; name: string; email: string; role: 'admin' | 'manager' | 'assistant' | 'dispatcher'; active: boolean; uid: string | null } & Retirement;
export type DriverDoc = { officeId: string; name: string; email: string; phone: string | null; active: boolean; uid: string | null } & Retirement;
export type PlaceDoc = { officeId: string; name: string; address: string; phone: string | null; memo: string | null };
/** driverId があると、そのドライバーも読める（配送指示のメモ） */
export type NoteDoc = { officeId: string; kind: 'batch' | 'stop' | 'alertAck' | 'issue'; text: string; driverId?: string };
/** ひな形の名前（荷主や行き先の名前が入りうる） */
export type TemplateDoc = { officeId: string; name: string };
/** 事務所の問い合わせ先（ID は事務所の ID）。配送アプリの設定に出す */
export type OfficeContactDoc = { officeId: string; name: string; phone: string; hours: string };
export type RollCallDetailDoc = { officeId: string; driverId: string; alcohol: number; expireAt?: unknown; healthOk?: boolean; healthNote?: string | null; inspectionOk?: boolean; instruction?: string | null };

/** このドライバーに見せてよい場所の印（ID は driverPlaceId）。名前や住所は持たない */
export type DriverPlaceDoc = { officeId: string; driverId: string; placeId: string };
export const driverPlaceId = (driverId: string, placeId: string) => `${driverId}_${placeId}`;

/** 行き先のメモの ID（指示を入れたときの順で決める。並べ替えても変わらない） */
export const stopNoteId = (batchId: string, inputSeq: number) => `${batchId}_${inputSeq}`;

/** チャットの本文（ID は D1 の messages と同じ）。createdAt はサーバーの時刻、expireAt は 1 年後（消す日） */
export type MessageDoc = {
  officeId: string; driverId: string; from: 'driver' | 'staff'; staffId: string | null;
  kind: 'text' | 'template' | 'broadcast'; text: string; deliveryNo: string | null; urgent: boolean;
  createdAt: unknown; expireAt: unknown;
};
/** チャットの定型文（officePhrases/{事務所} は事務所で共有、driverPhrases/{ドライバー} は本人ごと） */
export type PhrasesDoc = { officeId: string; driverId?: string; items: string[] };
/** 定期便の名前（ID は D1 の routines と同じ。取引先の名前が入りうる） */
export type RoutineDoc = { officeId: string; name: string };
